import {
    Button,
    IconButton,
    InputAdornment,
    TextField,
    TextFieldProps,
    useMediaQuery,
} from '@mui/material'
import { FC, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { BASE_API_URL } from '../../../../api/endpoints.constants'
import { Notistack } from '../../../../components/Notistack'
import { useProfileStore } from '../../../../store/storeProfile'
import { theme } from '../../../../theme'
import CopyIcon from './../../../../assets/icons/Copy.svg?react'

const getReferralLink = (userId: string) =>
    `${BASE_API_URL}/api/v1/auth/demo?checkword=J2bucFynEgnS&referer_uuid=${userId}`

const ReferralLinkInput: FC<TextFieldProps> = (props) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const { userTariff } = useProfileStore((state) => state)
    const personalReferralLink = userTariff && getReferralLink(userTariff?.user_uuid)
    const [openSnackbar, setOpenSnackbar] = useState(false)

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpenSnackbar(false)
    }

    return (
        <>
            <CopyToClipboard
                text={personalReferralLink ?? ''}
                onCopy={() => setOpenSnackbar(true)}>
                <Button
                    sx={{
                       padding: isMobile?  '10px 16px' : '10px 24px',
                    }}
                    id="ButtonCopyReferral"
                    startIcon={<CopyIcon />}
                    variant="contained"
                    color="primary"
                    >
                    Поделиться ссылкой
                </Button>
            </CopyToClipboard>

            <Notistack
                open={openSnackbar}
                isError={false}
                message="Ссылка скопирована"
                onClose={handleCloseSnackbar}
            />
        </>
    )
}

export default ReferralLinkInput
